export const PUMP_LINK =
  "https://pump.fun/coin/4KY6R8JjKz1imGYmRwyYFyC4ssuhekSFfzSZs62Tpump";
export const TWITTER_LINK = "https://x.com/DeptOfGovBoxing";
export const TELEGRAM_LINK = "https://t.me/GovBoxingPortal";
